import React, { memo } from 'react';
import './css/style.scss';
import { MdKeyboardArrowRight } from '../../../components/icons';
import dayjs from 'dayjs';
import LazyImage from '../../CustomLibraries/LazyImage';
import { certificate_static_image } from '../../../common/assets.common';

const Certificates = ({ data, click, gtmTagVariable }) => {
  return (
    <div
      className="w-100 certificatesCardV1Box rounded-3 overflow-hidden cursorPointer bg-white shadow position-relative overflow-hidden"
      onClick={click}
    >
      {(data?.file || data?.image) && (
        <LazyImage
          src={data?.file?.includes('.pdf') ? data?.image : data?.file}
          alt="certificate"
          className="w-100 h-auto"
          fallback_image={certificate_static_image}
        />
      )}

      <div className="overlay"></div>
      <div className="certificatesCardV1Content text-start position-absolute bottom-0 w-100 p-4 z-1">
        <h2 className="text-white fs-4 fw-medium mb-1 line-clamp-1">{data?.title}</h2>
        <h5 className="text-white fs-5 fw-normal">
          {data?.date != null && dayjs(data?.date).format('DD MMMM, YYYY')}
        </h5>
        <div className="rounded-circle cardArrow bg-secondary position-relative overflow-hidden">
          <MdKeyboardArrowRight customClass="fs-2 text-white position-absolute top-50 start-50 translate-middle" />
        </div>
      </div>
    </div>
  );
};

export default memo(Certificates);
